import './shared/lib/storage-migrate';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { router } from './app/router';
import {
  initAppBuild,
  isAppStale,
  markAppStale,
  reloadForNewBuild,
} from './shared/lib/app-build';
import { initWebVitals } from './shared/lib/web-vitals';
import { initVisualEffects } from './shared/lib/visual-effects';
import './app/styles.css';

(function applyThemeSync() {
  try {
    const raw = localStorage.getItem('pridex-theme');
    const mode = raw ? (JSON.parse(raw)?.state?.mode as string) : 'system';
    let theme: 'light' | 'dark' = 'light';
    if (mode === 'dark') theme = 'dark';
    else if (mode === 'light') theme = 'light';
    else if (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches) theme = 'dark';
    document.documentElement.setAttribute('data-theme', theme);
  } catch {
    const systemDark =
      typeof window !== 'undefined' &&
      window.matchMedia?.('(prefers-color-scheme: dark)').matches;
    document.documentElement.setAttribute('data-theme', systemDark ? 'dark' : 'light');
  }
})();

initAppBuild(import.meta.url);
let lastPathname = router.state.location.pathname;
let pathnameChangedAt = 0;
router.subscribe((state) => {
  if (state.location.pathname === lastPathname) return;
  lastPathname = state.location.pathname;
  pathnameChangedAt = Date.now();
  if (isAppStale()) reloadForNewBuild();
});

window.addEventListener('vite:preloadError', (event) => {
  markAppStale();
  if (Date.now() - pathnameChangedAt > 10_000) return;
  const key = 'pridex-chunk-reload-at';
  try {
    const last = Number(sessionStorage.getItem(key) ?? 0);
    if (Date.now() - last < 10_000) return;
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  reloadForNewBuild();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

initWebVitals();

initVisualEffects();
